<cb-dialog [dialogHeading]="dialogHeading" [showActions]="false" (cancelDialog)="cancel()">
    <div mat-dialog-content class="content">
        <label class="upload-btn">
            <input
                type="file"
                (change)="onFilesSelected($event)"
                multiple
                [attr.accept]="extension"
            />
            @if (!isUploading()) {
                <span>Upload images</span>
            } @else {
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            }
            <mat-icon style="vertical-align: middle; margin-right: 4px">file_upload</mat-icon>
        </label>

        <div
            cdkDropList
            cdkDropListOrientation="mixed"
            (cdkDropListDropped)="drop($event)"
            class="image-grid"
        >
            @for (img of files(); track img; let i = $index) {
                <div class="image-card" cdkDrag>
                    <button
                        mat-icon-button
                        class="drag-handle"
                        cdkDragHandle
                        aria-label="Drag to reorder"
                    >
                        <mat-icon>drag_handle</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        color="warn"
                        class="remove"
                        (click)="confirmRemove(img)"
                        aria-label="Remove image"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                    <div (click)="openImage(img)" class="image">
                        <img
                            [ngSrc]="img.url"
                            [alt]="img.name"
                            [width]="thumbSize().w"
                            [height]="thumbSize().h"
                        />
                    </div>
                    <div class="meta">
                        <span class="size">{{ getDimensions(img.id) }}</span>
                        <span class="name" title="{{ img.name }}">{{
                            img.name | cbTruncate: maxLength
                        }}</span>
                        <span class="order">#{{ img.sortOrder }}</span>
                    </div>
                </div>
            }
        </div>
    </div>
</cb-dialog>
